import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';

const CustomIconButton = (props) => {
    // State to manage the disabled status of the button
    const [internalDisabled, setInternalDisabled] = useState(false);

    const handleClick = (event) => {
        // Prevent execution if button is disabled (either from props or internal state)
        if (internalDisabled || props.disabled) return;

        // Call any existing onClick function passed in the props
        if (props.onClick) {
            props.onClick(event);
        }

        // Your custom functionality
        let audio = document.getElementById('btn-click-audio');
        if (audio) {
            audio.currentTime = 0;
            audio.volume = 0.02; // Set volume to 2%
            audio.play();
        }

        // Handle spam prevention if enabled
        // const preventSpam = props.preventSpam ?? true; // Default to true
        // if (preventSpam) {
        //     setInternalDisabled(true);
        //     let disableDuration = 2000; // Default to a reasonable 2000 ms (2 seconds)

        //     //if URL has #t then set disableDuration 500 vs. 2s
        //     if (window.location.hash.includes('#t')) {
        //         disableDuration = 1000;
        //     }

        //     setTimeout(() => {
        //         // Re-enable the button only if `props.disabled` is not true
        //         if (!props.disabled) {
        //             setInternalDisabled(false);
        //         }
        //     }, disableDuration);
        // }
    };



    // Calculate the final disabled state
    const isDisabled = props.disabled || internalDisabled;

    // Calculate dynamic styles for opacity when disabled
    const buttonStyle = {
        ...props.style, // Allow custom styles from props
        opacity: isDisabled ? 0.5 : 1, // Slightly transparent when disabled
        pointerEvents: isDisabled ? 'none' : 'auto', // Prevent pointer events when disabled
    };

    // Spread all props to the IconButton and override the necessary ones
    return (
        <>
            {/* isDisabled: {isDisabled ? 'true' : 'false'}<br />
            disabled: {props.disabled ? 'true' : 'false'}<br /> */}
        <IconButton
            {...props}
            style={buttonStyle}
            disabled={isDisabled} // Respect both props.disabled and internalDisabled
            onClick={handleClick}
            onTouchStart={handleClick}
        />
        </>
    );
};

export default CustomIconButton;